import styles from './keyboardShortcutsModal.module.css'
import { GLOBAL_SHORTCUTS } from '../../hooks/useKeyboardShortcuts'
// Importación directa a types para evitar dependencia circular con routes/index → router → app
import { RoutePath } from '../../../routes/types'

type Props = {
    isOpen: boolean
    onClose: () => void
    contextualModule?: RoutePath
}

const Kbd = ({ children }: { children: string }) => (
    <kbd className={styles.kbd}>{children}</kbd>
)

const PlusSep = () => <span className={styles.plus}>+</span>

export const KeyboardShortcutsModal = ({ isOpen, onClose, contextualModule }: Props) => {
    if (!isOpen) return null

    return (
        <div
            className={styles.overlay}
            role="dialog"
            aria-modal="true"
            aria-labelledby="kbd-modal-title"
            onClick={onClose}
        >
            <div className={styles.panel} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <h5 id="kbd-modal-title" className={styles.title}>Atajos de teclado</h5>
                    <button className="btn-close" onClick={onClose} aria-label="Cerrar" />
                </div>
                <div className={styles.body}>
                    <section className={styles.section}>
                        <p className={styles.sectionTitle}>Globales — abren en nueva pestaña</p>
                        <ul className={styles.list}>
                            {GLOBAL_SHORTCUTS.map(shortcut => (
                                <li key={shortcut.key} className={styles.item}>
                                    <span className={styles.keys}>
                                        <Kbd>Ctrl</Kbd><PlusSep /><Kbd>Alt</Kbd><PlusSep /><Kbd>{shortcut.key}</Kbd>
                                    </span>
                                    <span className={styles.label}>{shortcut.label}</span>
                                </li>
                            ))}
                        </ul>
                    </section>

                    {contextualModule && (
                        <section className={styles.section}>
                            <p className={styles.sectionTitle}>Contextual — pantalla actual</p>
                            <ul className={styles.list}>
                                <li className={styles.item}>
                                    <span className={styles.keys}>
                                        <Kbd>Ctrl</Kbd><PlusSep /><Kbd>Alt</Kbd><PlusSep /><Kbd>N</Kbd>
                                    </span>
                                    <span className={styles.label}>Crear nuevo registro</span>
                                </li>
                            </ul>
                        </section>
                    )}

                    <p className={styles.hint}>
                        <Kbd>Ctrl</Kbd><PlusSep /><Kbd>Alt</Kbd><PlusSep /><Kbd>Space</Kbd>
                        <span> abre/cierra este panel &nbsp;·&nbsp; </span>
                        <Kbd>Esc</Kbd>
                        <span> para cerrar</span>
                    </p>
                </div>
            </div>
        </div>
    )
}
